import { httpClient } from '@/services/http/httpClient'

type UpdateForumCommentParams = {
  id: string
  content: string
  file?: File
}

export async function updateForumComment({
  id,
  content,
  file,
}: UpdateForumCommentParams): Promise<void> {
  const payload = new FormData()
  payload.append('content', content)
  if (file) {
    payload.append('file', file)
  }

  await httpClient.put(`/ideas/forum/${id}`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
